/* eslint-disable react-redux/mapStateToProps-prefer-parameters-names */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Intercom from 'wanderu-component-intercom';
import {
    fetchIndexGuideAction,
} from 'wanderu-ducks-seo';
import { gtagEvent } from 'wanderu-service-analytics';
import Widget from 'wanderu-widget';

import { generateLocaleAwareGuideId } from '../../utils';
import PlaceGuideContainer from '../PlaceGuide/PlaceGuide';

class IndexGuideContainer extends Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            params,
        } = opts;

        const {
            mode,
            locale,
        } = params;

        const indexGuideId = generateLocaleAwareGuideId(params);

        await Promise.all([
            dispatch(
                fetchIndexGuideAction.fetchIndexGuide(indexGuideId, mode, locale),
            ),
            Widget.serverFetchData(opts),
        ]);

        await PlaceGuideContainer.serverFetchData({ ...opts, placeId: indexGuideId });
    }

    async componentDidMount() {
        const {
            match,
            isLoaded,
            indexGuideId,
            fetchIndexGuide,
        } = this.props;

        gtagEvent({
            event: 'page_view_index_guide',
        });

        if (!isLoaded) {
            const {
                mode,
                locale,
            } = match.params;

            fetchIndexGuide(indexGuideId, mode, locale);
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            match,
            indexGuideId,
        } = this.props;
        const {
            indexGuideId: previousIndexGuideId,
        } = prevProps;

        if (indexGuideId !== previousIndexGuideId) {
            const queryParams = match.params;

            this.props.fetchIndexGuide(
                indexGuideId,
                queryParams.mode,
                queryParams.locale,
            );
        }
    }

    render() {
        return (
            <>
                <PlaceGuideContainer
                    {...this.props}
                    placeGuideId={this.props.indexGuideId}
                    showInterlinkSection
                    showRoutesSection
                />
                <Intercom/>
            </>
        );
    }
}

IndexGuideContainer.propTypes = {
    fetchIndexGuide: PropTypes.func.isRequired,
    indexGuideId: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            locale: PropTypes.string.isRequired,
            mode: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

function mapStateToProps(appState, ownProps) {
    const {
        params,
    } = ownProps.match;
    const {
        mode,
    } = params;

    const indexGuideId = generateLocaleAwareGuideId(ownProps.match.params);

    return {
        indexGuideId,
        notFound: fetchIndexGuideAction.selectNotFound(appState, indexGuideId),
        error: fetchIndexGuideAction.selectError(appState, indexGuideId),
        isFetching: fetchIndexGuideAction.selectWorking(appState, indexGuideId),
        isLoaded: fetchIndexGuideAction.selectSuccess(appState, indexGuideId),
        travelMode: mode,
    };
}

const mapDispatchToProps = {
    fetchIndexGuide: fetchIndexGuideAction.fetchIndexGuide,
};

export {
    IndexGuideContainer,
    mapStateToProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexGuideContainer);
